import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { AuthProvider } from './context/AuthContext';
import './index.css';

// NOTE: StrictMode is intentionally omitted — React 18's double-mount in dev
// races @solana/wallet-adapter-react's listeners and breaks Phantom connect().
//
// AuthProvider gates the whole app: until a valid Supabase session exists, App
// renders <Login/> and the wallet/trading providers (mounted inside App) never
// load. Those providers live in App.jsx so they only initialize post-login.
createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
